import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { HttpStatus, managementHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import useContractRefundPaymentEmailTemplate, {
  ContractRefundPaymentEmailTemplateAction,
} from './ContractRefundPaymentEmailTemplate.Hooks';
import ContractRefundPaymentEmailTemplateDelete from './sections/ContractRefundPaymentEmailTemplate.Delete';
import ContractRefundPaymentEmailTemplateEdit from './sections/ContractRefundPaymentEmailTemplate.Edit';
import ContractRefundPaymentEmailTemplateFilters from './sections/ContractRefundPaymentEmailTemplate.Filters';
import ContractRefundPaymentEmailTemplateList from './sections/ContractRefundPaymentEmailTemplate.List';

export const contractRefundPaymentEmailTemplateIndexRoute =
  managementHomeRoute + '/contractRefundPaymentEmailTemplate/:action?/:id?';
export default function ContractRefundPaymentEmailTemplateIndex() {
  const { lang } = getLocales();
  const emailTemplateHook = useContractRefundPaymentEmailTemplate();

  if (!emailTemplateHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={emailTemplateHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.emailTemplates} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <ContractRefundPaymentEmailTemplateFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_EMAILTEMPLATE}
                    data={{ action: ContractRefundPaymentEmailTemplateAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <ContractRefundPaymentEmailTemplateFilters />}
            render={
              <>
                {views.edit && <ContractRefundPaymentEmailTemplateEdit />}
                {views.delete && <ContractRefundPaymentEmailTemplateDelete />}
                <ContractRefundPaymentEmailTemplateList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
